import { useState } from 'react';
import { Button } from '@mui/material';
import { MailOutline } from '@mui/icons-material';

import ContactSupportDialog from './ContactSupportDialog';

const LABEL = '¿Tienes alguna duda? Contacta con nosotros';

const ContactUsButton = ({
  variant = 'text',
  color = 'primary',
  sx = {},
  ...buttonProps
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant={variant}
        color={color}
        startIcon={<MailOutline />}
        onClick={() => setOpen(true)}
        sx={{ fontWeight: 500, ...sx }}
        {...buttonProps}
      >
        {LABEL}
      </Button>
      <ContactSupportDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default ContactUsButton;
